import React from "react";
export default (({
  styles = {},
  ...props
}) => <svg width="13" height="13" viewBox="0 0 13 13" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}><path d="M2.92 12.13c0-1.4-1.14-2.55-2.54-2.55M5.82 12.13c0-3.01-2.44-5.45-5.45-5.45M8.72 12.13A8.35 8.35 0 00.37 3.78M11.63 12.13C11.63 5.9 6.58.87.37.87" stroke="currentColor" strokeWidth="1.5" /></svg>);